import React, { useContext } from 'react';
import { Card } from 'react-bootstrap';
import CurrencyItem from '../../form/misc/CurrencyItem';
import DealContext from '../DealContext';

const ValuesCard = () => {
  const { aggregateValues } = useContext(DealContext);

  return (
    <Card className="values-card">
      <Card.Body>
        <Card.Title>Total Profit</Card.Title>
        <h2 className="text-right">
          <CurrencyItem>{aggregateValues.grossProfit}</CurrencyItem>
        </h2>
        <div className="data-line-item">
          <div className="data-line-item-label">Retail Price Total</div>
          <div className="data-line-item-amount">
            <CurrencyItem>{aggregateValues.retailPrice}</CurrencyItem>
          </div>
        </div>
        {aggregateValues.addonTotal !== 0 && (
          <div className="data-line-item">
            <div className="data-line-item-label">Add-on Total</div>
            <div className="data-line-item-amount">
              <CurrencyItem>{aggregateValues.addonTotal}</CurrencyItem>
            </div>
          </div>
        )}
        {aggregateValues.feesTotal !== 0 && (
          <div className="data-line-item">
            <div className="data-line-item-label">Fees Total</div>
            <div className="data-line-item-amount">
              <CurrencyItem>{aggregateValues.feesTotal}</CurrencyItem>
            </div>
          </div>
        )}
        {aggregateValues.warrantyTotal !== 0 && (
          <div className="data-line-item">
            <div className="data-line-item-label">Warranty Total</div>
            <div className="data-line-item-amount">
              <CurrencyItem>{aggregateValues.warrantyTotal}</CurrencyItem>
            </div>
          </div>
        )}
        {aggregateValues.salesTaxAmount !== 0 && (
          <div className="data-line-item">
            <div className="data-line-item-label">Sales Taxes</div>
            <div className="data-line-item-amount">
              <CurrencyItem>{aggregateValues.salesTaxAmount}</CurrencyItem>
            </div>
          </div>
        )}
        {aggregateValues.totalCosts !== 0 && (
          <div className="data-line-item">
            <div className="data-line-item-label">Total Costs</div>
            <div className="data-line-item-amount">
              <CurrencyItem>{aggregateValues.totalCosts}</CurrencyItem>
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default ValuesCard;
